import React, { useMemo, useState } from "react";
import { Tabs } from "@hid-galaxy-ui/galaxy-react";
import IntegrationPhases from "./integration-phases";
import Technologies from "./technologies";
import "./TechnologyManagement.scss";
import "../validation-management/feature-management/FeatureManagement.scss";

type TechnologyManagementProps = {
  readOnly?: boolean;
};

const TechnologyManagement: React.FC<TechnologyManagementProps> = ({
  readOnly = false,
}) => {
  const [activeTab, setActiveTab] = useState<string>("technology");

  const handleTabChange = (_: unknown, key: string) => {
    setActiveTab(key);
  };

  const tabItems = useMemo(
    () => [
      {
        key: "technology",
        label: "Technology",
        content: <Technologies readOnly={readOnly} />,
      },
      {
        key: "integration-phases",
        label: "Integration Phases",
        content: <IntegrationPhases readOnly={readOnly} />,
      },
    ],
    [readOnly]
  );

  return (
    <div className="technology-management">
      <Tabs
        theme="frameless"
        selectedKey={activeTab}
        items={tabItems}
        onClick={handleTabChange}
      />
    </div>
  );
};

export default TechnologyManagement;
